import { useEffect } from 'react';

/**
 * Fades [data-reveal] elements in as they scroll into view. The hidden starting state only
 * applies once <html> has the reveal-ready class, so nothing stays invisible without JS,
 * without IntersectionObserver, or with reduced motion.
 */
const useReveal = (deps = []) => {
    useEffect(() => {
        const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !('IntersectionObserver' in window)) return undefined;

        const root = document.documentElement;
        root.classList.add('reveal-ready');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { rootMargin: '0px 0px -8% 0px' });

        document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach((el) => observer.observe(el));
        return () => {
            observer.disconnect();
            root.classList.remove('reveal-ready');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};

export default useReveal;
